module.exports = __webpack_public_path__ + "static/residential-eb7b694784d1593ad7d8225bf78ac0dc.png";